import * as React from "react";
import { Header, Footer } from "../../shared";
import { Grid, Paper, Tooltip } from "@material-ui/core";
import { AdministrationMenu } from "../shared/menu/AdministrationMenu";
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import "./AccessReport.scss";


// tslint:disable-next-line:no-empty-interface
export interface IAccessReportProps {}

// tslint:disable-next-line:no-empty-interface
export interface IAccessReportState {}

export class AccessReport extends React.Component<
  IAccessReportProps,
  IAccessReportState
> {
  constructor(props: IAccessReportProps) {
    super(props);
  }

  public render() {
    return (
      <div className="access-report-page">
        <Header title={"Relatório de Acessos"} name={"Administrativo"} link={"/dashboard"} />
        
        <div className="access-report-body">
          <AdministrationMenu paramIcon={null} />

          <div className="wrapper">
            <Grid
              container={true}
              className="bookstore-sale-panel panel-grid"
              spacing={16}
            >
              <Grid item={true} xs={12} >
                <div>
                  <Paper className="analytical-panel">
                    <Grid container={true} className="analytical-header">
                        <Grid item={true} xs={10}>
                          <form>
                            <div className="analytical-date">
                                <TextField
                                id="initialDate"
                                label="Data inicial"
                                type="date"
                                required={true}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </div>
                            <TextField
                              id="endDate"
                              label="Data final"
                              type="date"
                              required={true}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                            <IconButton type="submit"  color="primary" >
                            <Tooltip title="Pesquisar">
                              <SendIcon/>
                              </ Tooltip>
                              </IconButton>
                          </form>
                        </Grid>
                    </Grid>
                  </Paper>
                        
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className="access-report-footer">
          <Footer />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/administration/reports/AccessReport.tsx